var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modalContents__object06",
      attrs: { "data-modalContents": "signup04" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row no-gutters" }, [
          _c(
            "div",
            { staticClass: "col-xl-6 col-lg-8 col-md-11 col-12 mx-auto" },
            [
              _c("h2", { staticClass: "text-center" }, [
                _vm._v("MEMBERSHIP INFO.")
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "row no-gutters",
                  attrs: { id: "signup04_form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.send($event)
                    }
                  }
                },
                [
                  _c("h3", { staticClass: "col-12" }, [
                    _vm._v("■ プラン内容（登録内容のご変更をご確認ください）")
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "col-12 row no-gutters" }, [
                    _c("dt", { staticClass: "col-3" }, [_vm._v("視聴プラン")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_plan" }
                      },
                      [_vm._v(_vm._s(_vm.dispPlan()))]
                    ),
                    _vm._v(" "),
                    _vm.mailmagazine_change
                      ? _c("dt", { staticClass: "col-3" }, [
                          _vm._v("メールマガジン")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mailmagazine_change
                      ? _c(
                          "dd",
                          {
                            staticClass: "col-9",
                            attrs: { id: "signup_confirm_mm01" }
                          },
                          [
                            _vm._v(
                              "「ニッポンの問題点」を購読" +
                                _vm._s(
                                  _vm.$store.state.inputData.mm01
                                    ? "する"
                                    : "しない"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mailmagazine_change
                      ? _c("dt", { staticClass: "col-3" }, [
                          _vm._v("メールマガジン")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mailmagazine_change
                      ? _c(
                          "dd",
                          {
                            staticClass: "col-9",
                            attrs: { id: "signup_confirm_mm02" }
                          },
                          [
                            _vm._v(
                              "「読むオプエド」を購読" +
                                _vm._s(
                                  _vm.$store.state.inputData.mm02
                                    ? "する"
                                    : "しない"
                                )
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.$store.state.inputData.payment_type == "credit"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-12",
                          attrs: { id: "signup_confirm_credit" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("h3", { staticClass: "col-12" }, [
                              _vm._v(
                                "■ お支払い方法（登録内容をご確認ください）"
                              )
                            ]),
                            _vm._v(" "),
                            _c("dl", { staticClass: "col-12 row no-gutters" }, [
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("決済方法")
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-9" }, [
                                _vm._v("PAY.jp 定期課金")
                              ]),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("ご請求額(税込)")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_credit_price" }
                                },
                                [_vm._v(_vm._s(_vm.dispCreditPrice()) + "円")]
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.inputData.payment_type == "bank"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-12",
                          attrs: { id: "signup_confirm_bank" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("h3", { staticClass: "col-12" }, [
                              _vm._v(
                                "■ お支払い方法（登録内容をご確認ください）"
                              )
                            ]),
                            _vm._v(" "),
                            _c("dl", { staticClass: "col-12 row no-gutters" }, [
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("決済方法")
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-9" }, [
                                _vm._v("銀行振込")
                              ]),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("振込名義人")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_bank_name" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$store.state.inputData.bank_name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("ご契約期間")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_bank_month" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.state.inputData.bank_month
                                    ) + "ヵ月"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("ご請求額(税込)")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_bank_price" }
                                },
                                [_vm._v(_vm._s(_vm.dispBankPrice()) + "円")]
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c(
        "button",
        {
          staticClass:
            "text-center btn modalContents__object06--submit globalModal--btn",
          attrs: {
            id: "signup_submit",
            "data-modal": "signupSubmit",
            type: "submit"
          }
        },
        [_vm._v("プランを変更する")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "col-12 row no-gutters" }, [
      _c("li", { staticClass: "col-12" }, [
        _c("strong", [_vm._v("表示金額は税込の金額")]),
        _vm._v("になります。")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "col-12" }, [
        _vm._v("カード決済を選択された場合、毎月1日の決済となります。")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "col-12" }, [
        _vm._v(
          "銀行振込を選択された場合、ブロンズ会員以上のお申し込みの方には、ご登録後に"
        ),
        _c("strong", [
          _vm._v("お振込方法などを詳しく説明したメールをお送りいたします。")
        ]),
        _vm._v(
          "入金確認まではブロンズ会員として、ニューズ・オプエドをお楽しみください。"
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c70faca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c70faca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/mypage_edit_plan_confirm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5c70faca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/mypage_edit_plan_confirm.vue
// module chunks = 0